const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
// @Components
const { OKButton } = require('components/commons/OKButton/OKButton');
// @constants
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    }
} = require('constants/chat');
require('./ChatSendMessage.scss');

class ChatSendMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMessage: '',
            placeholder: formatText('chat-enterMessage')
        };

        this.handleMessageChange = this.handleMessageChange.bind(this);
        this.handleSendMessage = this.handleSendMessage.bind(this);
        this.handlePressKeyMessage = this.handlePressKeyMessage.bind(this);
    }

    handleMessageChange(e) {
        const inputValue = e.target.value;
        const currentMessage = inputValue.charCodeAt(0) === 10 ? '' : inputValue;

        this.setState({
            currentMessage,
            placeholder: ''
        });

    }

    handlePressKeyMessage(e) {
        if (e.keyCode === 13 && e.shiftKey === false) {
            this.handleSendMessage();
        }
    }

    handleSendMessage() {
        const { sendMessage, startConversation, conversationStatus } = this.props;
        const { currentMessage } = this.state;
        if (currentMessage.trim()) {
            if (conversationStatus === INACTIVE) {
                startConversation(currentMessage);
            }
            this.setState({
                currentMessage: '',
                placeholder: ''
            });
            if(conversationStatus === ACTIVE){
                sendMessage(currentMessage);
            }
        }
    }

    isButtonDisabled() {
        const { currentMessage, conversationStatus } = this.state;
        const { showCloseQuestion } = this.props;
        return showCloseQuestion || conversationStatus === DISCONNECTED || conversationStatus === CONNECTING || !currentMessage.trim();
    }

    isInputDisabled() {
        const { showCloseQuestion, conversationStatus, msgReceiveFail, timer } = this.props;
        return showCloseQuestion || conversationStatus === CONNECTING || (msgReceiveFail && timer);
    }

    renderErrorSendingMessage() {
        const { currentMessage } = this.state;
        const { maximumMessageLength } = this.props;
        let response;

        if (maximumMessageLength && currentMessage.length >= maximumMessageLength) {
            response = (
                <div className="chat-send-message__error">
                    <FormattedText
                        injectedStrings={[maximumMessageLength]}
                        value="chatWarning-charsLimit"
                    />
                </div>
            );
        }

        return response;
    }

    render() {
        const { currentMessage, placeholder } = this.state;
        const { maximumMessageLength } = this.props;
        const errorSendingMessage = this.renderErrorSendingMessage();
        return (
            <div className="chat-send-message">
                <div className="chat-send-message__wrapper-input">
                    <textarea className="chat-send-message__input"
                        placeholder={placeholder}
                        autoSize="none"
                        disabled={this.isInputDisabled()}
                        maxLength={maximumMessageLength}
                        onChange={this.handleMessageChange}
                        onKeyDown={this.handlePressKeyMessage}
                        value={currentMessage}
                    />
                </div>
                <div className="chat-send-message__wrapper-button">
                    <OKButton isOKButtonOld={true} //this button should be changed to an action
                        size="small"
                        icon="icon-siguiente"
                        modifier="secondary-circle"
                        onClick={this.handleSendMessage}
                        disabled={this.isButtonDisabled()}
                    >
                        <div className="chat-send-message__wrapper-icon">
                            <i className="icon-siguiente" />
                        </div>
                    </OKButton>
                </div>
                { errorSendingMessage }
                <div className="clearfix" />
            </div>
        );
    }
}

ChatSendMessage.propTypes = {
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    maximumMessageLength: PropTypes.number,
    msgReceiveFail: PropTypes.bool,
    sendMessage: PropTypes.func.isRequired,
    showCloseQuestion: PropTypes.bool.isRequired,
    startConversation: PropTypes.func.isRequired,
    timer: PropTypes.bool
};

module.exports = ChatSendMessage;
